import React, { useState, useEffect, useContext } from "react"
import { MultiSelect, Group, Text, Combobox, Pill, useCombobox, Input, InputBase } from "@mantine/core"
import { IoSearchOutline } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";
import { nodeTypes } from "../../types";
import { getHardcodedColor } from "../../utils";
import UserSelectionContext from "../../providers/UserSelectionProvider";
import { getAllMoas } from "../../services/moas";

interface SearchFieldProps {
  onOptionSelect: (option: string) => void;
}

const MoaSearchField: React.FC<SearchFieldProps> = ({ onOptionSelect }) => {
  const [data, setData] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { selectedMoa, SetSelectedMoa } = useContext(UserSelectionContext)
  const [search, setSearch] = useState('');

  const combobox = useCombobox({
    onDropdownClose: () => {
      combobox.resetSelectedOption();
      combobox.focusTarget();
      setSearch('');
    },

    onDropdownOpen: () => {
      combobox.focusSearchInput();
    },
  });
  const options = loading ? [] : data
    .filter((item) => item.toLowerCase().includes(search.toLowerCase().trim()))
    .map((item) => (
      <Combobox.Option value={item} key={item}>
        {item}
      </Combobox.Option>
    ));

  useEffect(() => {
    const callGetAllMoas = async () => {
      const names = await getAllMoas();
      setData(names);
      setLoading(false)
    };
    callGetAllMoas()
  }, [])

  return (
    <Combobox
      store={combobox}
      onOptionSubmit={(val) => {
        SetSelectedMoa(val);
        combobox.closeDropdown();
      }}
    >
      <Combobox.Target>
        <InputBase
          component="button"
          type="button"
          pointer
          rightSection={<Combobox.Chevron />}
          rightSectionPointerEvents="none"
          onClick={() => combobox.toggleDropdown()}
          styles={{
            input: {
              backgroundColor: 'rgb(198,198,206, 0.2)',
              border: 0,
              color: "#f3f3f7"
            }
          }}
        >
          {selectedMoa ? <Pill style={{ backgroundColor: getHardcodedColor(nodeTypes.moa), color: 'white' }}>{selectedMoa}</Pill>
            : <Input.Placeholder>Select MoA</Input.Placeholder>}
        </InputBase>
      </Combobox.Target>

      <Combobox.Dropdown>
        <Combobox.Search
          value={search}
          onChange={(event) => setSearch(event.currentTarget.value)}
          placeholder="Search for MoA"
        />
        <Combobox.Options>{options}</Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  )
};

export default MoaSearchField;
